import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function WorkFormats() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const formats = [
    {
      icon: 'ri-chat-3-line',
      title: t('wf.f1.title'),
      subtitle: t('wf.f1.subtitle'),
      desc: t('wf.f1.desc'),
      features: [t('wf.f1.feat1'), t('wf.f1.feat2'), t('wf.f1.feat3'), t('wf.f1.feat4')],
      highlight: false,
      cta: t('wf.f1.cta'),
    },
    {
      icon: 'ri-settings-3-line',
      title: t('wf.f2.title'),
      subtitle: t('wf.f2.subtitle'),
      desc: t('wf.f2.desc'),
      features: [t('wf.f2.feat1'), t('wf.f2.feat2'), t('wf.f2.feat3'), t('wf.f2.feat4')],
      highlight: false,
      cta: t('wf.f2.cta'),
    },
    {
      icon: 'ri-stack-line',
      title: t('wf.f3.title'),
      subtitle: t('wf.f3.subtitle'),
      desc: t('wf.f3.desc'),
      features: [t('wf.f3.feat1'), t('wf.f3.feat2'), t('wf.f3.feat3'), t('wf.f3.feat4')],
      highlight: true,
      cta: t('wf.f3.cta'),
    },
  ];

  return (
    <section className="py-24" style={{ backgroundColor: '#F8F9FB' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase mb-3 block">{t('wf.badge')}</span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('wf.title')}
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto">
            {t('wf.desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {formats.map((format) => (
            <div
              key={format.title}
              className={`rounded-2xl p-8 border relative flex flex-col ${
                format.highlight
                  ? 'bg-blue-600 border-blue-600 text-white'
                  : 'bg-white border-gray-100'
              }`}
            >
              {format.highlight && (
                <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                  <span className="bg-white text-blue-700 text-xs font-semibold px-5 py-1.5 rounded-full tracking-wide">
                    {t('wf.popular')}
                  </span>
                </div>
              )}

              <div className={`w-11 h-11 flex items-center justify-center rounded-xl mb-4 ${
                format.highlight ? 'bg-white/20' : 'bg-blue-50'
              }`}>
                <i className={`${format.icon} text-xl ${format.highlight ? 'text-white' : 'text-blue-600'}`}></i>
              </div>

              <div className="mb-4">
                <h3 className={`text-lg font-bold mb-0.5 ${format.highlight ? 'text-white' : 'text-gray-900'}`}>
                  {format.title}
                </h3>
                <span className={`text-xs font-medium ${format.highlight ? 'text-blue-200' : 'text-blue-600'}`}>
                  {format.subtitle}
                </span>
              </div>

              <p className={`text-sm leading-relaxed mb-6 ${format.highlight ? 'text-blue-100' : 'text-gray-500'}`}>
                {format.desc}
              </p>

              <ul className="flex flex-col gap-2.5 mb-8 flex-1">
                {format.features.map((feature, fi) => (
                  <li key={fi} className="flex items-start gap-3">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`ri-check-line text-sm ${format.highlight ? 'text-blue-200' : 'text-blue-600'}`}></i>
                    </div>
                    <span className={`text-sm leading-snug ${format.highlight ? 'text-blue-100' : 'text-gray-600'}`}>{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                className={`whitespace-nowrap w-full py-3 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                  format.highlight
                    ? 'bg-white text-blue-700 hover:bg-blue-50'
                    : 'border border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white'
                }`}
                onClick={() => navigate('/contact')}
              >
                {format.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
